import {
  HttpInternalServerException,
  HttpInvalidRequestException,
  HttpNotFoundException,
  HttpForbiddenException
} from 'exceptions'

export default function httpExceptionUtil(e) {
  if (e.response.status === 400) {
    return new HttpInvalidRequestException(e.response.data.errors)
  } else if (e.response.status === 403) {
    return new HttpForbiddenException(e.response.data.errors)
  } else if (e.response.status === 404) {
    return new HttpNotFoundException(e.response.data.errors)
  } else if (e.response.status === 500) {
    return new HttpInternalServerException(e.response.data.errors)
  }
}
